enum CommonTypes {
  POST_SHARE_REQUEST = 'POST_SHARE_REQUEST',
  POST_SHARE_SUCCESS = 'POST_SHARE_SUCCESS',
  POST_SHARE_ERROR = 'POST_SHARE_ERROR',
}

export default CommonTypes;
